import { IFormValues } from '../../DealRentModal';
import { useFormikContext, getIn } from 'formik';

export const useFieldHasErrors = (name: keyof IFormValues) => {
  const { touched, errors } = useFormikContext<IFormValues>();

  return Boolean(getIn(touched, name) && getIn(errors, name));
};
